import React, { useEffect } from 'react'
import Skeleton from 'react-loading-skeleton'
import PropTypes from 'prop-types'

import InfoModal from '../InfoModal'
import { ReactComponent as WarningIcon } from '../../../../assets/icons/warning-icon.svg'

import useStyles from './styles'

const DeleteItemModalWrapper = ({
  isDeleteModalOpened,
  handleCloseDeleteModal,
  getListItemHandler,
  clearHandler,
  itemWasLoaded,
  loadedItem,
  children
}) => {
  const classes = useStyles()

  const isDeleteAllowed =
    // do not allow to delete item if it has impressions
    !loadedItem?.impressions

  useEffect(() => {
    if (isDeleteModalOpened) {
      getListItemHandler()
    } else {
      clearHandler()
    }
  }, [isDeleteModalOpened, getListItemHandler, clearHandler])

  if (!itemWasLoaded) {
    return (
      <InfoModal className={classes.modal} isOpen={isDeleteModalOpened} onClose={handleCloseDeleteModal}>
        <Skeleton width={'40%'} height={30} style={{ marginTop: 60, marginBottom: 20 }} />
        <Skeleton width={'40%'} height={20} />
      </InfoModal>
    )
  } else if (isDeleteAllowed) {
    return children
  } else {
    return (
      <InfoModal
        Icon={WarningIcon}
        modalTitle="This item cannot be deleted because it already has started delivering."
        isOpen={isDeleteModalOpened}
        onClose={handleCloseDeleteModal}
      ></InfoModal>
    )
  }
}

DeleteItemModalWrapper.propTypes = {
  isDeleteModalOpened: PropTypes.bool,
  handleCloseDeleteModal: PropTypes.func,
  getListItemHandler: PropTypes.func,
  clearHandler: PropTypes.func,
  itemWasLoaded: PropTypes.bool,
  loadedItem: PropTypes.object,
  children: PropTypes.node
}

export default DeleteItemModalWrapper
